const isCustomVINValid = (vin) => {
  // Remove non-alphanumeric characters and convert to uppercase
  const cleanVin = vin.replace(/[^A-Z0-9]/gi, '').toUpperCase()

  // Check length and valid characters
  if (cleanVin.length !== 17 || /[IOQ]/.test(cleanVin)) {
    return false
  }

  // Calculate the check digit
  const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2]
  const transliteration = {
        'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5, 'F': 6, 'G': 7, 'H': 8, 'J': 1, 'K': 2, 'L': 3, 'M': 4, 'N': 5, 'P': 7, 'R': 9, 'S': 2, 'T': 3, 'U': 4, 'V': 5, 'W': 6, 'X': 7, 'Y': 8, 'Z': 9
  }

  // Calculate the check digit
  const sum = [...vin].reduce((acc, char, index) => {
    const value = transliteration[char] || parseInt(char, 10)
    return acc + value * weights[index]
  }, 0)
  const checkDigit = (sum % 11) % 10

  // Check if the calculated check digit matches the VIN's check digit
  return checkDigit === parseInt(vin[8], 10)
}

const isCustomYearValid = (input) => {
    if (input.length !== 4 || !/^\d+$/.test(input)) return false

    const currentYear = new Date().getFullYear()
    if (input.length !== 4 || isNaN(input) || input > currentYear) return false

    return true
}

export {
    isCustomVINValid,
    isCustomYearValid
}
